<template>
  <v-select
      v-model="input"
      :items="options"
      :label="hideLabel ? '' : 'Ставка ндс'"
      item-text="text"
      item-value="value"
      :disabled="disabled"
      :error-messages="errorMessages"
      @blur="() => {this.$emit('blur')}"
      @change="onChange"
      :dense="dense"
      :outlined="outlined"
      :hide-details="hideDetails"
  />
</template>

<script>
export default {
  name: "SelectNdsRate",
  data() {
    return {
      input: null,
      options: []
    }
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default() {
        return []
      }
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init() {
      // init options
      this.options = [
        {value: null, text: 'Без НДС'},
        {value: 0, text: '0 %'},
        {value: 15, text: '15 %'}
      ]
    },
    onChange() {
      this.$emit('input', this.input)
      this.$emit('change', this.input)
    },
    onValueChanged() {
      this.input = this.value
    }
  },
  created() {
    this.init()
    this.onValueChanged()
  },
  watch: {
    value() {
      this.onValueChanged()
    }
  }
}
</script>

<style scoped>

</style>